module.exports = {
    "id": "papaya",
    "title": "papaya",
    "image": "provision/parts/papaya/papaya.png",
    "info": [
      {
        "text": "Add a papaya to your project.",
        "image": "provision/parts/papaya/papaya.png"
      }
    ],
    "exposedVariables": []
};